import { hostnames } from 'features/common/config/envConfig';
import { AuditLogsSupportedSystemName } from '../constants';

export const baseAuditLogsApiUrl = {
  [hostnames.internal]:
    // 'https://edge-platform-staging.sitecore-staging.cloud/v1/audit',
    'https://audit-api-staging.sitecore-staging.cloud/api/v2',
  [hostnames.localhost]:
    // 'https://edge-platform-staging.sitecore-staging.cloud/v1/audit',
    'https://audit-api-staging.sitecore-staging.cloud/api/v2',
  [hostnames.dev]:
    //'https://edge-platform-dev.sitecore-staging.cloud/v1/audit',
    'https://audit-api-dev.sitecore-staging.cloud/api/v2',
  [hostnames.qa]:
    //'https://edge-platform-qa.sitecore-staging.cloud/v1/audit',
    'https://audit-api-qa.sitecore-staging.cloud/api/v2',
  [hostnames.staging]:
    //'https://edge-platform-staging.sitecore-staging.cloud/v1/audit',
    'https://audit-api-staging.sitecore-staging.cloud/api/v2',
  [hostnames.beta]: 'https://edge-platform-preprod.sitecorecloud.io/v1/audit',
  [hostnames['pre-production']]:
    'https://edge-platform-preprod.sitecorecloud.io/v1/audit',
  [hostnames.production]: 'https://edge-platform.sitecorecloud.io/v1/audit',
};

export const auditLogsApi = {
  get_logs: {
    /**
     * Build URL for fetching audit logs, including optional search query.
     */
    url: ({
      system,
      continuationToken,
      query,
    }: {
      system: AuditLogsSupportedSystemName;
      continuationToken: string;
      query?: string;
    }) => {
      let url = `${
        baseAuditLogsApiUrl[window.location.hostname]
      }/logs?system=${system}&continuationToken=${continuationToken}`;
      if (query) {
        url += `&query=${encodeURIComponent(query)}`;
      }
      return url;
    },
    scope: 'audit.logs:r',
  },
};
